import { render, staticRenderFns } from "./ExploreTrainings.vue?vue&type=template&id=5d827d08&scoped=true"
import script from "./ExploreTrainings.vue?vue&type=script&lang=js"
export * from "./ExploreTrainings.vue?vue&type=script&lang=js"
import style0 from "./ExploreTrainings.vue?vue&type=style&index=0&id=5d827d08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d827d08",
  null
  
)

export default component.exports